// Sidebar.js
import React, { useState, useEffect } from 'react';
import {
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Layout, Menu, theme } from 'antd';
import { Link } from 'react-router-dom';
import { Dashboard } from '@mui/icons-material';

const { Sider } = Layout;

function getItem(label, key, children,) {
  return {
    key,
    children,
    label,
  };
}


const Sidebar = ({ collapsed, onCollapse }) => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const items = [
    // getItem('Dashboard', 'sub1',
    //  [
    //   getItem('Export', '3'),
    // ]
    getItem(<Link className='home-link' to="/Dashboard">Dashboard</Link>, '1'),
    getItem('Store', 'sub2', [
      getItem(<Link className='home-link' to="/productreg">Product Registration</Link>, '6'),
      getItem(<Link className='home-link' to="/ratesettings">Rate Settings</Link>, '8'),
      getItem(<Link className='home-link' to="/staffreg">Staff Registration</Link>, '23'),

      getItem(<Link className='home-link' to="/taxgroup">Tax Group Registration</Link>, '9'),
      getItem('Other Registration', '10', [
        getItem(<Link className='home-link' to="/rateclassreg">Rate Class Registration</Link>, '11'),
        getItem(<Link className='home-link' to="/stockgroup">Stock Group</Link>, '12'),
      ]),
      getItem('Account Registration', '24', [
        getItem(<Link className='home-link' to="/groupreg">Group Registration</Link>, '25'),
        getItem(<Link className='home-link' to="/ledgerreg">Ledger Registration</Link>, '26'),
      ]),
    ]),
    getItem('Menu/Items', 'sub3', [
      getItem('Data 1', '13'),
      getItem('Data  2', '14'),
    ]),
    getItem('Reports', 'sub4', [
      getItem('Data  1', '15'),
      getItem('Data  2', '16'),
    ]),
    getItem('Inventry', 'sub5', [
      getItem('Data 1', '17'),
      getItem('Data  2', '18'),
    ]),
    getItem('Account Report', 'sub6', [
      getItem('Data 1', '19'),
      getItem('Data  2', '20'),
    ]),
    getItem('Tools', 'sub7', [
      getItem('Data  1', '21'),
      getItem('Data  2', '22'),
    ]),

  ];


  return (
    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse} className="responsive-sidebar">
      {!collapsed && <h3 className='head1'> SherDine</h3>}
      <Menu theme="	#003083" style={{color: "		#0098f1"}} defaultSelectedKeys={['']} mode="inline" items={items} />
    </Sider>
  );
};

export default Sidebar;
 
